const JetlympicRouter = {
  path: '/jetlympic',
  name: 'Jetlympic',
  redirect: '/jetlympic/entrance',
  component: () => import('@/views/jetlympic/index'),
  children: [
    {
      path: 'home',
      name: 'JetlympicHome',
      component: () => import('@/views/jetlympic/home'),
      meta: { title: 'Jetlympic运动会' }
    },
    {
      path: 'login',
      name: 'JetlympicLogin',
      component: () => import('@/views/jetlympic/login'),
      meta: { title: '员工登录' }
    },
    {
      path: 'list',
      name: 'JetlympicList',
      component: () => import('@/views/jetlympic/list'),
      meta: { title: '赛事报名' }
    },
    {
      path: 'entrance',
      name: 'JetlympicEntrance',
      component: () => import('@/views/jetlympic/entrance'),
      meta: { title: 'Jetlympic运动会' }
    },
    {
      path: 'live-matches',
      name: 'JetlympicLiveMatches',
      component: () => import('@/views/jetlympic/live-matches'),
      meta: { title: '赛事直播' }
    },
    {
      path: 'schedule',
      name: 'JetlympicSchedule',
      component: () => import('@/views/jetlympic/schedule'),
      meta: { title: '赛程查询' }
    },
    {
      path: 'hotel',
      name: 'JetlympicHotel',
      component: () => import('@/views/jetlympic/hotel'),
      meta: { title: '住宿信息' }
    },
    {
      path: 'video',
      name: 'JetlympicVideo',
      component: () => import('@/views/jetlympic/video'),
      meta: { title: '视频' }
    },
    {
      path: 'shuttle',
      name: 'JetlympicShuttle',
      component: () => import('@/views/jetlympic/shuttle'),
      meta: { title: '接驳车信息' }
    }
  ]
}
export default JetlympicRouter
